/*=========================================================================================
  File Name: moduleChequeBookActions.js
  Description: ChequeBook Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';

export default {
  async CreateBankbook({}, Credentials) {
    delete Credentials.ledger_type_id;
    // delete CredentiaCreateChequeBookls.id;

    return new Promise((resolve, reject) => {
      axios
        .post(
          `bank-books/bank-account/${Credentials.bank_account_id}`,
          Credentials,
        )
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async CreateChequeBook({}, Credentials) {
    // delete CredentiaCreateChequeBookls.id;

    return new Promise((resolve, reject) => {
      axios
        .post('cash-books', Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async GetAllChequeBook({}, payload = '') {
    return new Promise((resolve, reject) => {
      axios
        .get(`cash-books?shop=${payload.shop}&date=${payload.date}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async EditBankbook({}, Credentials) {
    return new Promise((resolve, reject) => {
      let ID = Credentials.id;

      delete Credentials.created_at;
      delete Credentials.id;
      delete Credentials.updated_at;
      delete Credentials.deleted_at;
      delete Credentials.reference_number;
      delete Credentials.shop;
      delete Credentials.bank;
      delete Credentials.user;
      delete Credentials.warehouse;
      axios
        .patch(`bank-books/${ID}`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async EditChequeBook({}, Credentials) {
    return new Promise((resolve, reject) => {
      let ID = Credentials.id;

      delete Credentials.created_at;
      delete Credentials.id;
      delete Credentials.updated_at;
      delete Credentials.deleted_at;
      delete Credentials.reference_number;
      delete Credentials.shop;
      delete Credentials.user;
      delete Credentials.warehouse;
      axios
        .patch(`cash-books/${ID}`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  ActiveOrArchiveChequeBook({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`cash-books/${Id}/soft-delete`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async getSinglebankbook({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`bank-books/${Id}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async GetChequeBook({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`cash-books/${Id}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
